import commonMutations from '@/store/data/common/mutations'
import { findIndex, isEmpty, keys, includes, toNumber, toString, isNil } from 'lodash'
import Vue from 'vue'

const mutations = {
    setTransfers(state, { items }) {
        state.list = items
    },
    setTransferList(state, items ) {
        state.transferList = items
    },
    setTransfersActiveError(state, error ) {
        state.transfersActiveError = error
    },

    setTransfersWithSameAudienceId(state, { audienceId, items }) {
        if (isEmpty(state.list)) {
            state.list = items
        } else {
            const audiencesIds = keys(state.list)
            if (includes(audiencesIds, toString(audienceId))) {
                state.list = {
                    ...state.list,
                    [audienceId]: [...state.list[audienceId], ...items[audienceId]]
                }
            } else {
                state.list = {
                    ...state.list,
                    [audienceId]: items[audienceId]
                }
            }
        }
    },

    setEditedTransfer(state, { audienceId, items }) {
        Vue.set(state.list, `${audienceId}`, items)
    },
    setEditedFlatTransfer( state, { transferId, item}) {
        const index = state.transferList.findIndex(({ id }) => +id === +transferId)
        Vue.set(state.transferList, index, item)
    },
    removeTransfersFromAudienceId(state, { audienceId }) {
        state.transferList = state.transferList.filter(({ audience_id }) => +audience_id !== +audienceId)
        Vue.delete(state.list, audienceId)
    },
    removeTransferFromAudienceId(state, { transferId, audienceId }) {
        const indexOfTransferToRemove = findIndex(state.list[audienceId], item => toNumber(item.id) === toNumber(transferId))
        Vue.delete(state.list[audienceId], indexOfTransferToRemove)
    },
    removeTransfersFromAudiences(state, transfers) {
        transfers.forEach( ({ transferId, audienceId }) => {
            const indexOfTransferToRemove = findIndex(state.list[audienceId], item => toNumber(item.id) === toNumber(transferId))
            Vue.delete(state.list[audienceId], indexOfTransferToRemove)
        })
    },
    removeTransferFromTransferList(state, id) {
        state.transferList = state.transferList.filter( transfer => +transfer.id !== +id)
    },
    removeTransfersFromTransferList(state, transfers) {
        transfers.forEach( ({ transferId }) => {
            state.transferList = state.transferList.filter( transfer => +transfer.id !== +transferId)
        })
    },
    setTransferInfos(state, transferId) {
        const transfer = state.transferList.find(({ id }) => +id === +transferId)
        state.transferInfos = !isNil(transfer) ? transfer : {}
    },
    setTransferInfosUpdated(state, { key, item}) {
        if (key === 'end_date') {
            Vue.set(state.transferInfos, 'status', 'active')
            Vue.set(state.transferInfos, 'endDate', item[key])
        }
        Vue.set(state.transferInfos, key, item[key])
    },
    setResetBulkSelectedRows(state, reset) {
        state.resetBulkSelectedRows = reset
    },
    setIsUpdatedOrDeletedLoading(state, loading) {
        state.isUpdatedOrDeletedLoading = loading
    },
    setListTransferNoVolume(state, updated) {
        state.listTransferNoVolume = updated
    },
    setUpdatedBulkList(state, transfers) {
        state.updatedBulkList = transfers
    }

}

export default { ...commonMutations, ...mutations }
